/*
 * PASS-943 Modal components taken from @rally/connect-components (a.k.a telemedicine-components)
 * adjusted for RDS-based styling
 */
import React, { HTMLAttributes } from 'react';
import cx from 'classnames';
import styled from 'styled-components';

import { Text } from '@pass-frontend/common/components/typography/ui';
import { RdsButton } from '@pass-frontend/rally-energon-react';

type FooterHTMLAttributes = HTMLAttributes<HTMLDivElement>;
export interface Props extends FooterHTMLAttributes {
  primaryButtonText?: string;
  secondaryButtonText?: string;
  className?: string;
  primaryButtonClassName?: string;
  secondaryButtonClassName?: string;
  areFooterButtonsRowAligned?: boolean;
}

const FooterWithStyledText = (props: FooterHTMLAttributes) => (
  <Text tag="footer" {...props} />
);

const Footer = styled(FooterWithStyledText)``;

const renderConfirmButton = (
  areFooterButtonsRowAlignedButton: boolean | undefined,
  props,
) => {
  const { primaryButtonText, primaryButtonClassName } = props;

  const primaryClassName = `primary-btn ${primaryButtonClassName || ''}`;
  if (!primaryButtonText) {
    return null;
  }
  return (
    <RdsButton
      data-ui-element-name={primaryButtonText}
      data-testid={primaryButtonText}
      className={`${primaryClassName} ${
        !areFooterButtonsRowAlignedButton ? 'filter-button-size' : ''
      }`}
    >
      {primaryButtonText}
    </RdsButton>
  );
};

const renderSecondaryButton = (
  areFooterButtonsRowAlignedButton: boolean | undefined,
  props,
) => {
  const { secondaryButtonText, secondaryButtonClassName } = props;

  if (!secondaryButtonText) {
    return null;
  }
  return (
    <RdsButton
      data-ui-element-name={secondaryButtonText}
      data-testid={secondaryButtonText}
      type="button"
      variant="secondary"
      className={`secondary-btn close-btn ${secondaryButtonClassName || ''} ${
        !areFooterButtonsRowAlignedButton ? 'filter-button-size' : ''
      }`}
    >
      {secondaryButtonText}
    </RdsButton>
  );
};

export const ModalFooter = (props: Props) => {
  const {
    primaryButtonText,
    secondaryButtonText,
    primaryButtonClassName,
    secondaryButtonClassName,
    children,
    areFooterButtonsRowAligned,
    ...footerAttributes
  } = props;
  if (!primaryButtonText && !secondaryButtonText) {
    return null;
  }

  const doAllButtonsExist = !!primaryButtonText && !!secondaryButtonText;

  return (
    <Footer className={`${props.className}`} {...footerAttributes}>
      {/* footer can now have either horizontal or vertical alignment of buttons */}
      <div
        className={cx({
          'is-flex': areFooterButtonsRowAligned && doAllButtonsExist,
          'is-flex is-flex-direction-column is-align-items-center':
            !areFooterButtonsRowAligned && doAllButtonsExist,
          'is-flex-direction-row':
            areFooterButtonsRowAligned && doAllButtonsExist,
          'has-rds-mb-16': !areFooterButtonsRowAligned,
          'has-rds-mb-32': areFooterButtonsRowAligned,
        })}
      >
        <div
          className={cx({
            'has-rds-mb-16 is-flex is-align-items-center is-justify-content-center':
              !areFooterButtonsRowAligned,
          })}
        >
          {renderConfirmButton(areFooterButtonsRowAligned, props)}
        </div>
        {/* for side by side buttons */}
        <div
          className={cx({
            'is-flex is-align-items-center is-justify-content-center':
              !areFooterButtonsRowAligned,
            'has-rds-ml-16': areFooterButtonsRowAligned,
          })}
        >
          {renderSecondaryButton(areFooterButtonsRowAligned, props)}
        </div>
      </div>

      {/* currently no existing implementation with usage of additional footing elements  */}
      {children && <div>{children}</div>}
    </Footer>
  );
};
